module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [_c('div', {
    staticClass: "page page-rating-inner"
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "page-bg"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": "/rating"
    }
  }, [_vm._v("назад")]), _vm._v(" "), _c('div', {
    staticClass: "week-name-wrapper"
  }, [_c('div', {
    staticClass: "week-name"
  }, [_c('h3', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.week.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])]), _vm._v(" "), (_vm.weekWinner) ? _c('div', {
    staticClass: "best-of-week"
  }, [_c('div', {
    staticClass: "best-of-week__inner"
  }, [(!_vm.Helpers.isTouch()) ? _c('div', {
    staticClass: "best-of-week__cup-image"
  }, [_c('svg-cup')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "best-of-week__winner"
  }, [('user' in _vm.weekWinner) ? _c('div', {
    staticClass: "players-item"
  }, [(_vm.Helpers.isTouch()) ? _c('div', {
    staticClass: "best-of-week__cup-image"
  }, [_c('svg-cup')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "best-of-week__winner-header"
  }, [_vm._v("Победитель недели")]), _vm._v(" "), _c('div', {
    staticClass: "player-left"
  }, [_c('div', {
    staticClass: "player-avatar",
    style: ('image_link' in _vm.weekWinner.user ? ("background-image: url(" + (_vm.weekWinner.user.image_link) + ")") : '')
  })]), _vm._v(" "), _c('div', {
    staticClass: "player-right"
  }, [_c('p', {
    staticClass: "player-name"
  }, [_vm._v(_vm._s(_vm.weekWinner.user.first_name) + " " + _vm._s(_vm.weekWinner.user.last_name))]), _vm._v(" "), _c('div', {
    staticClass: "player-data"
  }, [(_vm.weekWinner.result) ? _c('div', {
    staticClass: "player-time"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.toHHMMSS(_vm.weekWinner.result.time)))]), _c('span', {
    staticClass: "icon"
  }, [_c('clock')], 1)]) : _vm._e(), _vm._v(" "), (_vm.weekWinner.result) ? _c('div', {
    staticClass: "player-points"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.weekWinner.result.score))]), _c('span', {
    staticClass: "icon"
  }, [_c('star')], 1)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "best-of-week__cross"
  }, [_c('svg-cross')], 1), _vm._v(" "), _c('div', {
    staticClass: "players-item"
  }, [_c('div', {
    staticClass: "best-of-week__winner-header"
  }, [_vm._v("Футболист недели")]), _vm._v(" "), _c('div', {
    staticClass: "player-left"
  }, [_c('div', {
    staticClass: "player-avatar",
    style: (("background-image: url(" + (_vm.weekWinner.player_photo) + ")"))
  })]), _vm._v(" "), _c('div', {
    staticClass: "player-right"
  }, [_c('p', {
    staticClass: "player-name"
  }, [_vm._v(_vm._s(_vm.weekWinner.player_name))])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "players-scroll-wrapper",
    class: {
      fixedHeight: _vm.list.length >= 15
    }
  }, [_c('div', {
    staticClass: "players-scroll"
  }, [_c('ul', {
    staticClass: "players-list"
  }, _vm._l((_vm.list), function(item, key) {
    return _c('li', {
      staticClass: "players-item"
    }, [_c('div', {
      staticClass: "player-left"
    }, [_c('div', {
      staticClass: "player-position"
    }, [_vm._v(_vm._s(item.position))]), _vm._v(" "), (item.image_link) ? _c('div', {
      staticClass: "player-avatar",
      style: (("background-image: url(" + (item.image_link) + ")"))
    }) : _c('div', {
      staticClass: "player-avatar"
    })]), _vm._v(" "), _c('div', {
      staticClass: "player-right"
    }, [_c('p', {
      staticClass: "player-name"
    }, [_vm._v(_vm._s(item.first_name) + " " + _vm._s(item.last_name))]), _vm._v(" "), _c('div', {
      staticClass: "player-data"
    }, [_c('div', {
      staticClass: "player-time"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.toHHMMSS(item.time)))]), _c('span', {
      staticClass: "icon"
    }, [_c('clock')], 1)]), _vm._v(" "), _c('div', {
      staticClass: "player-points"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.score))]), _c('span', {
      staticClass: "icon"
    }, [_c('star')], 1)]), _vm._v(" "), (item.link) ? _c('div', {
      staticClass: "player-videolink"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": item.link
      }
    }, [_vm._v("+ видеоповтор")])]) : _vm._e()])])])
  }))])])]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link link-next-week",
    class: {
      active: _vm.nextWeekActive
    },
    attrs: {
      "to": '/rating/' + _vm.nextWeekIdx
    }
  }, [(_vm.weeks[_vm.nextWeekIdx - 1] !== undefined) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.weeks[_vm.nextWeekIdx - 1].name)
    }
  }) : _vm._e()])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d00f06b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/RatingInner.vue
// module id = 514
// module chunks = 1